<template>
  <b-modal
    :visible="visible"
    hide-header
    hide-footer
    centered
    size="lg"
    :modal-class="`theme-${$setup.theme}-modals`"
    @change="$emit('change', $event)"
  >
    <div class="topic-composer-modal">
      <div class="modal-top d-flex align-items-center justify-content-between">
        <h5 class="mb-0">Criar Tópico</h5>
        <button class="btn-close-modal" @click="close">
          <i class="icon-close" />
        </button>
      </div>

      <div class="composer-user d-flex align-items-center">
        <div class="avatar">
          <img v-if="userPhoto" :src="userPhoto" :alt="userName" />
          <span v-else class="letter">{{ userInitial }}</span>
        </div>
        <span class="user-name">{{ userName }}</span>
      </div>

      <rich-text-editor v-model="text" placeholder="Digite um texto..." />

      <div v-if="image" class="composer-image mt-2">
        <img :src="image" alt="" />
        <button type="button" class="btn-remove-image" @click="image = null">
          Remover imagem
        </button>
      </div>

      <input-image id="topic-composer-image" v-model="image" class="mt-3">
        <span class="btn-attach">
          <i class="icon-image" /> Adicionar Imagem
        </span>
      </input-image>

      <div class="d-flex align-items-center justify-content-end mt-4">
        <button class="btn btn-outline-secondary mr-2" @click="close">
          Cancelar
        </button>
        <button
          class="btn btn-primary px-4"
          :disabled="loading || !canSubmit"
          @click="submit"
        >
          <loading :show="loading" small>Publicar</loading>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import InputImage from "@/components/InputImage.vue";
import RichTextEditor from "./RichTextEditor.vue";

export default {
  name: "TopicComposerModal",
  components: { InputImage, RichTextEditor },
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    forumId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      text: "",
      image: null,
      loading: false
    };
  },
  computed: {
    user() {
      return (this.$user && this.$user.user) || {};
    },
    userName() {
      return this.user.name || "Você";
    },
    userPhoto() {
      return this.user.photo;
    },
    userInitial() {
      return (this.userName[0] || "?").toUpperCase();
    },
    canSubmit() {
      return !!(this.text && this.text.trim()) || !!this.image;
    }
  },
  methods: {
    close() {
      this.$emit("change", false);
    },
    submit() {
      if (!this.canSubmit) return;
      this.loading = true;
      this.$store
        .dispatch("community/createForumPost", {
          forumId: this.forumId,
          text: this.text,
          image: this.image
        })
        .then(post => {
          this.$message.success("Tópico criado");
          this.text = "";
          this.image = null;
          this.$emit("created", post);
          this.close();
        })
        .catch(error => {
          const message =
            error?.response?.data?.non_field_errors?.[0] ||
            "Não foi possível publicar";
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.topic-composer-modal {
  .modal-top {
    margin-bottom: 16px;

    h5 {
      font-weight: 600;
    }

    .btn-close-modal {
      border: none;
      background: transparent;
      color: inherit;
      padding: 0;
      opacity: 0.7;

      &:hover {
        opacity: 1;
      }

      i {
        font-size: 16px;
      }
    }
  }

  .composer-user {
    gap: 10px;
    margin-bottom: 16px;

    .avatar {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(128, 128, 128, 0.2);
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .letter {
        font-size: 14px;
        font-weight: 500;
      }
    }

    .user-name {
      font-weight: 500;
      font-size: 14px;
    }
  }

  .composer-image {
    position: relative;
    display: inline-block;

    img {
      max-width: 100%;
      max-height: 240px;
      border-radius: 8px;
    }

    .btn-remove-image {
      display: block;
      margin-top: 4px;
      border: none;
      background: transparent;
      color: #ff757e;
      font-size: 12px;
      padding: 0;
    }
  }

  .btn-attach {
    display: inline-flex;
    align-items: center;
    font-size: 14px;

    i {
      font-size: 18px;
      margin-right: 6px;
    }
  }
}
</style>
